import {
  useCompanyMenu,
  useImprintMenu,
  useKnowYourRightsMenu,
  useLegalMenu,
  useProductsMenu,
  useSupportMenu,
  useTopMenu,
  useExperimentalTopMenu,
} from "./useMenu";

export {
  useCompanyMenu,
  useImprintMenu,
  useKnowYourRightsMenu,
  useLegalMenu,
  useProductsMenu,
  useSupportMenu,
  useTopMenu,
  useExperimentalTopMenu,
};
